import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ tokens })=>({
        multipleRadioInput: {
            width: '100%',
            marginBottom: tokens.spacing['16'],
            '& .MuiFormGroup-row': {
                marginBottom: 0
            }
        }
    }));
const MultipleRadioInput_styles = useStyles;
export default MultipleRadioInput_styles;
